import Cookies from "js-cookie";
import moment from "moment";
import ExportJsonExcel from "js-export-excel";
import "moment/dist/locale/zh-cn";
moment.locale("zh-cn");
moment.suppressDeprecationWarnings = true;

/**
 * 开始时间和结束时间的时间差
 * @param {*} endTime 结束时间
 * @param {*} startTime 开始时间
 * @param {*} diff 单位 months-月、days-天、minutes-分、seconds-秒
 * @returns
 */
export function timeDifference(endTime, startTime, diff) {
  return moment(endTime).diff(moment(startTime), diff);
}

/**
 * 格式化时间
 * @param date
 * @param format
 * @returns {string}
 */
export function dateFormat(date, format = "YYYY/MM/DD HH:mm:ss") {
  if (!date) return;
  return moment(date).format(format);
}

/**
 * 字节转Mb
 * @param {*} size 数值
 * @param {*} point 小数位数
 * @returns
 */
export function sizeTostr(size, point) {
  return ((size * 8) / (1024 * 1024)).toFixed(point);
}

/**
 * 获取cookie
 * @param { string} key  名称
 * @returns
 */
export function getCookie(key) {
  return Cookies.get(key);
}

/**
 * 设置cookie
 * @param {string} key 名称
 * @param {string} value 值
 * @param {number} expires 保存天数
 * @returns
 */

export function setCookie(key, value, expires) {
  return Cookies.set(key, value, { expires: expires });
}

/**
 * 删除cookie
 * @param {*} key 名称
 * @returns
 */
export function removeCookie(key) {
  return Cookies.remove(key);
}

// 判空
export function _isNullorEmpty(value) {
  if (
    typeof value === "undefined" ||
    value == null ||
    value === "" ||
    JSON.stringify(value) === "{}" ||
    JSON.stringify(value) === "[]"
  ) {
    return true;
  } else {
    return false;
  }
}

// 实时获取窗口可视区域大小
export function getWindowInner() {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
}

/**
 * 导出Excel 表格
 * @param {Array} dataList 数据
 * @param {String} name 表格名称
 * @param {Array} sheetHeader 表头
 * @param {Array} sheetFilter 表头对应的字段
 * @param {Array} columnWidths 表格宽度
 */
export const exportExcel = (
  dataList = [],
  name = "列表",
  sheetHeader = [],
  sheetFilter = [],
  columnWidths = []
) => {
  // let sheetFilter = ["name", "leaveType", "leaveCount", "leaveDuration"];

  let option = {};
  option.fileName = name;
  option.datas = [
    {
      sheetData: dataList,
      sheetName: name,
      sheetFilter,
      // sheetHeader: ["姓名", "类型", "次数", "时长"],
      sheetHeader,
      columnWidths,
      // columnWidths: [10, 10, 10, 10],
    },
  ];
  let toExcel = new ExportJsonExcel(option); //new
  toExcel.saveExcel(); //保存
};
